// extracted by mini-css-extract-plugin
export default {"tradeSizeInfo":"TradeSizeInput_tradeSizeInfo__ENvWJ","inputGroup":"TradeSizeInput_inputGroup__Tqzum"};